<template>
    <footer class="bg-white text-gray-700 pt-12 pb-6 w-full">
      <div class="px-6 sm:px-6 md:px-8 lg:px-10 xl:px-12">
        <!-- Footer top section with columns -->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 mb-10 antialiased">
          
          <!-- Company info -->
          <div>
            <h3 class="text-2xl font-semibold mb-4">PHISOFT</h3>
            <p class="text-gray-600 text-md mb-4 text-xl">
              PT Pasifik Hoki Indonesia A member of PSG Group
            </p>
            <div class="flex space-x-4 mt-4">
              <a href="https://www.linkedin.com/company/phisoft-id/posts/?feedView=all" target="_blank" class="text-gray-800 hover:text-[#186A85]">
                <i class="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.instagram.com/phisoft.id" target="_blank" class=" text-gray-800 hover:text-[#186A85] ">
                <i class="fab fa-instagram "></i>
              </a> 
            </div><br>
          </div>
        
          <div>
            <h3 class="text-xl font-semibold mb-2">Quick Links</h3>
            <ul class="space-y-2 text-lg">
              <li><router-link to="/" class="text-gray-600 hover:text-black">Home</router-link></li>
              <li><router-link to="/about" class="text-gray-600 hover:text-black">About Us</router-link></li>
              <a href="https://phisoft.co.id/blog/" target="_blank" rel="noopener noreferrer" class="hover:text-teal-500 transition">
            Blog
          </a>
              <li><router-link to="/contact" class="text-gray-600 hover:text-black">Contact</router-link></li>
            </ul>
          </div>
          <!-- Contact column -->
          <div>
            <h3 class="text-xl font-semibold mb-4">Contact Us</h3>
            <ul class="space-y-3 text-lg">
              <li class="flex items-center">
                <i class="fas fa-phone mr-3 text-[#186A85]"></i>
                <span class="text-gray-600">(081) 11623222</span>
              </li>
              <li class="flex items-center">
                <i class="fas fa-envelope mr-3 text-[#186A85]"></i>
                <span class="text-gray-600">halo@phisoft.co.id</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-map-marker-alt mt-1 mr-3 text-[#186A85]"></i>
                <span class="text-gray-600 text-justify">
                  Gold Coast Office, Liberty Tower OTB 20B, Pantai Indah Kapuk, Kota Jakarta Utara, Daerah Khusus Ibukota Jakarta, 14470 - Indonesia
                </span>
              </li>
            </ul>
          </div>
        </div>
  
        <div class="border-t-2 border-gray-600"></div>
  
        <!-- Copyright -->
        <div class="border-t border-gray-700 pt-6 flex flex-col md:flex-row justify-between items-center text-gray-00 text-xl text-center md:text-left antialiased">
          <p>&copy; 2025 PT Pasifik Hoki Indonesia (PHISOFT). All Rights Reserved.</p>
          <p>Operational Hours: Monday - Friday (09:00 - 16:00)</p>
        </div>
      </div>
    </footer>
</template>
  